export default __webpack_public_path__ + "static/media/loginmask.da9732b5.jpg";